module.exports = __webpack_public_path__ + "assets/images/ert_sports1.a3bb0d3155eae234ddb795197f6d9920.png";